import React from 'react';
import { getCredentialingContractBanner } from 'api/credentialing';
import type { TCredentialingContractBanner, TCredentialingContractView } from 'types/credentialing';

const globalDataMap: Record<string, TCredentialingContractBanner[]> = {};

const useContractBanner = (view: TCredentialingContractView = 'provider'): [TCredentialingContractBanner[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TCredentialingContractBanner[]>(globalDataMap[view] || []);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingContractBanner(view);
            if (result && !result.error) {
                const list: TCredentialingContractBanner[] = result?.data?.data || [];
                globalDataMap[view] = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [view]);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useContractBanner;
